import { useContext } from 'react';
import FirebaseContext from 'firebase/context';

const useFirebaseContext = () => useContext(FirebaseContext);

export default useFirebaseContext;
